import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
  Input,
  ViewEncapsulation,
  HostListener,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'timeline',
  styleUrls: ['./timeline.component.scss'],
  templateUrl: './timeline.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HistoryTimelineComponent implements OnInit {
  // Binding properties

  @Input('items')
  public set items(value: any[]) {
    this._items = value;
  }
  public get items() {
    return this._items;
  }
  private _items: any[];

  @Input('iconMapping')
  public set iconMapping(value: any) {
    this._iconMapping = value;
  }
  public get iconMapping() {
    return this._iconMapping;
  }
  private _iconMapping: any;

  @Input('emptyMessage')
  public set emptyMessage(value: string) {
    this._emptyMessage = value;
  }
  public get emptyMessage() {
    return this._emptyMessage;
  }
  private _emptyMessage: string;

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {}
}
